var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H32V32H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M22.333,17.667a4,4,0,1,1,4-4A4,4,0,0,1,22.333,17.667Zm-12-4a5.333,5.333,0,1,1,5.333-5.333A5.333,5.333,0,0,1,10.333,13.667Z",
    transform: "translate(1.667 1)",
    fill: "#35ce77",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M23.468,15.667c4.542.05,8.251,2.346,8.53,7.2a.679.679,0,0,1-.723.8H26.133A13.274,13.274,0,0,0,23.468,15.667ZM0,22.6C.518,16.235,5.683,13,11.978,13,18.362,13,23.607,16.058,24,22.6a.916.916,0,0,1-1,1.067H.97A1.476,1.476,0,0,1,0,22.6Z",
    transform: "translate(0 4.333)",
    fill: "#35ce77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirPeople);
export default __webpack_public_path__ + "static/media/cir_people.e4318e51a31ee11ec33bc8201dcb2494.svg";
export { ForwardRef as ReactComponent };